import {FC, useEffect} from 'react'
import {Navigate, Outlet, useLocation} from 'react-router-dom'
import {useAuth2} from '../modules/authv2/Auth2Provider'
import {InfoUserProvider} from './store/InfoUserProvider'

const ProtectedRoute: FC = () => {
  const {userData} = useAuth2()
  const location = useLocation()
  const token = localStorage.getItem('authToken')

  useEffect(() => {
    if (!token) {
      const urlLogout = localStorage.getItem('urlLogout')
      if (urlLogout) {
        window.location.replace(urlLogout)
      }
    }
  }, [token])

  const hasValidUserData = userData && Object.keys(userData).length > 0

  if (!hasValidUserData || !token) {
    return <Navigate to='/auth/callback' state={{from: location}} replace />
  }

  return (
    <InfoUserProvider>
      <Outlet />
    </InfoUserProvider>
  )
}

export {ProtectedRoute}
